import type { Icon as TablerIcon } from '@tabler/icons-react';
import {
  IconFile,
  IconFolder,
  IconStack2,
} from '@tabler/icons-react';
import { ProductRole, ProductType } from '@cabal/shared/domain/session/product/enums.js';
// Every glyph here is the OUTLINE variant. Cicon passes `stroke` to the icon,
// and a Filled variant silently ignores it — so a filled member reads heavier
// than everything beside it, which is exactly how this map drifted.
export const PRODUCT_TYPE_ICONS: Record<ProductType, TablerIcon> = {
  [ProductType.Content]: IconFile,
  [ProductType.Folder]: IconFolder,
  [ProductType.Collection]: IconStack2,
};

export function productNodeIcon(input: { type: ProductType; role: ProductRole | null }): TablerIcon {
  // Structural (base-type) icon; the role renders as a separate badge beside it
  return PRODUCT_TYPE_ICONS[input.type];
}
